// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"362": "LazyIdentificationForm","616": "LazyGoogleOneTap",}[chunkId] + "." + {"362": "d8370585911a8b07","616": "2c4c96c6aa91b94b",}[chunkId] + ".js"
}